import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import pluralize from "lib/pluralize";
import Badge from "hardcover-ui/components/Badge";
import truncate from "lodash/truncate";
import UserByline from "components/users/UserByline";
import PrivacyIcon from "components/shared/PrivacyIcon";
import BookGroupHeaderWrapper from "./parts/BookGroupHeaderWrapper";
import { BookGroupSizeType, BookListContextType } from "../types";
import ListUserReadCountLoader from "./parts/ListUserReadCountLoader";

export default function BookListHeader({
  context,
  size,
}: {
  context: BookListContextType;
  size: BookGroupSizeType;
}) {
  return (
    <BookGroupHeaderWrapper size={size}>
      <div className="flex flex-row space-x-2 mb-1">
        <Text variant="secondary" as="p" size="sm" className="font-semibold">
          {context.list.featured && <span>Featured </span>}
          List
        </Text>
        <Badge
          size="sm"
          variant={context.list.featured ? "accent" : "secondary"}
        >
          {context.list.booksCount.toLocaleString()}{" "}
          {pluralize("book", context.list.booksCount)}
        </Badge>
        <ListUserReadCountLoader
          size="md"
          listId={context.list.id}
          count={context.list.booksCount}
        />
        {context.list.privacySettingId !== 1 && (
          <Badge size="sm" variant="secondary" className="space-x-1">
            <PrivacyIcon
              privacySettingId={context.list.privacySettingId}
              size="md"
            />
            <span>
              {context.list.privacySettingId === 2
                ? "Followers Only List"
                : "Private List"}
            </span>
          </Badge>
        )}
      </div>

      <Heading
        level={3}
        size={size === "lg" ? "md" : size === "md" ? "sm" : "xs"}
        className="mb-2"
      >
        <TextLink
          href={`/@${context.list.user.username}/lists/${context.list.slug}`}
          underline={false}
        >
          {context.list.name}
        </TextLink>
      </Heading>

      {size === "lg" && (
        <Text variant="secondary" as="p">
          {truncate(context.list.description, {
            length: size === "lg" ? 200 : 140,
          })}
        </Text>
      )}

      <UserByline user={context.list.user} size="sm" />
    </BookGroupHeaderWrapper>
  );
}
